import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';
import * as VatReturnService from 'services/api/vatreturn_list';

interface IState {
  vatReturnList: any;
  vatReturnListAll: any;
  schemeTypesList: any;
  quarterList: any;
  monthQuarterList: any;
  addVatReturnStatus: StateStatus | null | undefined;
  vatCreationUserInfo: any;
  addVatReturnPaymentStatus: StateStatus | null | undefined;
  addVatReturnPaymentRespone: any;
  agentTraders: {
    status: StateStatus | null | undefined;
    data: Array<VatReturnService.ITradersInfo>;
  };
}

const initialState: IState = {
  schemeTypesList: {
    status: null,
    data: null,
  },
  vatReturnList: {
    status: null,
    data: null,
  },
  vatReturnListAll: {
    status: null,
    data: null,
  },
  quarterList: {
    status: null,
    data: null,
  },
  monthQuarterList: {
    status: null,
    data: null,
  },
  addVatReturnStatus: null,
  vatCreationUserInfo: {
    status: null,
    data: null,
  },
  addVatReturnPaymentStatus: null,
  addVatReturnPaymentRespone: null,
  agentTraders: {
    status: null,
    data: [],
  },
};

const VatReturnReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_VATRETURN_LIST:
      return {
        ...state,
        vatReturnList: {
          ...state.vatReturnList,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.vatReturnList.data
              : action.data,
        },
      };
    case Types.SET_VATRETURN_LIST_ALL:
      return {
        ...state,
        vatReturnListAll: {
          ...state.vatReturnListAll,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.vatReturnListAll.data
              : action.data,
        },
      };
    case Types.SET_SCHEME_TYPES:
      return {
        ...state,
        schemeTypesList: {
          ...state.schemeTypesList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_QUARTER_TYPES:
      return {
        ...state,
        quarterList: {
          ...state.quarterList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_MONTH_QUARTER_TYPES:
      return {
        ...state,
        monthQuarterList: {
          ...state.monthQuarterList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.ADD_VATRETURN:
      return {
        ...state,
        addVatReturnStatus: action.status,
      };
    case Types.SET_USER_INFO_VAT_RETURN_CREATION:
      return {
        ...state,
        vatCreationUserInfo: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.ADD_VAT_RETURN_PAYMENT:
      return {
        ...state,
        addVatReturnPaymentStatus: action.status,
        addVatReturnPaymentRespone: action.data,
      };
    case Types.SET_AGENT_TRADERS:
      return {
        ...state,
        agentTraders: {
          status: action.status,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default VatReturnReducer;
